<script setup lang="ts">
import {
  homeSectionsDataProvider,
} from '~/layers/homepage/data/homeSectionsDataProvider'
import HomeSectionCollection from "~/layers/homepage/components/content/HomeSectionCollection.vue";
import HomeSectionSlider from "~/layers/homepage/components/content/HomeSectionSlider.vue";
import HomeSectionAnimation from "~/layers/homepage/components/content/HomeSectionAnimation.vue";
import HomeSectionDiamondHistory from "~/layers/homepage/components/content/HomeSectionDiamondHistory.vue";
import HomeSectionCustomSlider from "~/layers/homepage/components/content/HomeSectionCustomSlider.vue";
import {type THomeSection, THomeSectionType} from "~/layers/homepage/data/types";
import {useAsyncData} from "#app";

const provider =  homeSectionsDataProvider()

const {data: sections} = await useAsyncData(() => provider.load())

const sectionContentComponentMap: Record<any, any> = {
  [THomeSectionType.Collection]: HomeSectionCollection,
  [THomeSectionType.Slider]: HomeSectionSlider,
  [THomeSectionType.Animation]: HomeSectionAnimation,
  [THomeSectionType.DiamondHistory]: HomeSectionDiamondHistory,
  [THomeSectionType.CustomSlider]: HomeSectionCustomSlider,
}

const getContentComponent = (section: THomeSection) => {
  return sectionContentComponentMap[section.type]
}
</script>

<template>
  <HomeSection v-for="(section, index) in sections" :key="'section_' + index" :section="section">
    <component :is="getContentComponent(section)" :section="section" />
  </HomeSection>
</template>
